import { ZOOM_DEFAULT_SURFACE_RATIO, ZOOM_MAX_RATIO, ZOOM_MIN_RATIO } from '@/config';
import type { TZoomBounds } from '@/utils/TZoomBounds';

type TZoomFactorParams = {
    canvasHeight: number;
    canvasWidth: number;
    surfaceHeight: number;
    surfaceWidth: number;
};

// Zoom at which the print surface spans ZOOM_DEFAULT_SURFACE_RATIO of the
// canvas' tighter axis — the default view. Pure so it can be re-derived on
// every read instead of cached and invalidated on resize.
function computeDefaultZoomFactor(params: TZoomFactorParams): number {
    if (params.surfaceWidth <= 0 || params.surfaceHeight <= 0) {
        return 1;
    }
    return Math.min(
        (params.canvasWidth / params.surfaceWidth) * ZOOM_DEFAULT_SURFACE_RATIO,
        (params.canvasHeight / params.surfaceHeight) * ZOOM_DEFAULT_SURFACE_RATIO,
    );
}

function computeZoomBounds(params: TZoomFactorParams): TZoomBounds {
    const defaultZoomFactor = computeDefaultZoomFactor(params);
    return { max: defaultZoomFactor * ZOOM_MAX_RATIO, min: defaultZoomFactor * ZOOM_MIN_RATIO };
}

export { computeDefaultZoomFactor, computeZoomBounds };
